import React from 'react';
import styles from './SplitSectionItem.module.scss';

export const SplitSectionRow = ({
  children,
}: {
  children: React.ReactNode;
}) => <>{children}</>;

const SplitSectionItem = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.item}>{children}</div>
);

export default SplitSectionItem;
